import React from "react";
import {
  Button,
  Col,
  Form,
  InputGroup,
  Modal,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import Fontstyling from "../../../components/common/comman";
import { clientListDrpDwnStyles } from "../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../../components/common/CustomButton";
import DeleteModal from "../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../components/common/CustomMaterialTable";
import toastFile from "../../../Service/ToastFile";
import CustomInputField from "../../../components/common/CustomInputField";
import Required from "../../../components/Required";
import {
  AddEmpowerXSpecialtyDrugLIst,
  GetEmpoweRxSpecialtyDrugList,
  GetPBMList,
  DeleteEmpoweRxSpecialtyDrug,
  ImportEmpoweRxSpecialtyDrug,
  AddDataToEmpoweRxSpecialtyDrug,
  GetEmpoweRxSpecialtyDrugListGroup,
  DeleteEmpoweRxSpecialtyDrugListGroup,
} from "../../../api/EmpowRxApi";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import { getClientsDatabyPaginationbySearch } from "../../../api/User/commonApi";
import { IoEyeOutline } from "react-icons/io5";
import { BiSolidDownload } from "react-icons/bi";
import editIcon from "../../../assets/icon/pencil-fill.svg";
import editIconWhite from "../../../assets/icon/pencil-fill-white.svg";
import deletIcon from "../../../assets/icon/trash-solid.svg";
import deletIconWhite from "../../../assets/icon/trash-solid-white.svg";
import { DownloadCensusErrorFile } from "../../../api/User/ACG/ImportCensusApi";
import { IoCheckmarkCircle } from "react-icons/io5";
import { FaPencil } from "react-icons/fa6";
import { round } from "lodash";
import moment from "moment/moment";
import { Loader } from "rsuite";

const schema1 = Yup.object().shape({
  PBM: Yup.string().trim().required("Please select PBM Name"),
  client: Yup.object().nonNullable().required("Please select Client Name"),
  file: Yup.mixed().required("Please select File"),
});
const schema = Yup.object().shape({
  NDC11: Yup.string().trim().required("Please enter NDC"),
  DrugName: Yup.string().trim().required("Please enter Drug name"),
  TherapyClass: Yup.string().trim().required("Please enter Therapy class"),
  LimitedDistributionDrugIndicator: Yup.string()
    .trim()
    .required("Please select Limited Distrubution Drug Indicator"),
  BiosimilarIndicator: Yup.string()
    .trim()
    .required("Please select Biosimilar Indicator"),
  BrandorGenericIndicator: Yup.string()
    .trim()
    .required("Please select Brand or Generic Indicator"),
  Mail_Specialty_AWP_Discount: Yup.number()
    .typeError("Please enter a valid number.")
    .max(0.99, "Please enter between 0.00 to less than 1")
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .required("Please enter Mail Specialty AWP Discount"),
  Mail_Specialty_Dispensing_Fee: Yup.number()
    .typeError("Please enter a valid number.")
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .required("Please enter Mail Specialty Dispensing Fee"),
  Retail_Specialty_AWP_Discount: Yup.number()
    .typeError("Please enter a valid number.")
    .max(0.99, "Please enter between 0.00 to less than 1")
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .required("Please enter Retail Specialty AWP Discount"),
  Retail_Specialty_Dispensing_Fee: Yup.number()
    .typeError("Please enter a valid number.")
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .required("Please enter Retail Specialty Dispensing Fee"),
  Specialty_Pharmacy_AWP_Discount: Yup.number()
    .typeError("Please enter a valid number.")
    .max(0.99, "Please enter between 0.00 to less than 1")
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .required("Please enter Specialty Pharmacy AWP Discount"),
  Specialty_Pharmacy_Dispensing_Fee: Yup.number()
    .typeError("Please enter a valid number.")
    .moreThan(-0.001, "Number must be a valid  positive number.")
    .required("Please enter Specialty Pharmacy Dispensing Fee"),
  Rebateable_Drug: Yup.string().trim().required("Please enter Rebateable Drug"),
});

const SpecialtyDrugList = () => {
  const user = useSelector((state) => state.userDetails.value);
  const [data, setData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [rowDataID, setRowDataID] = useState([]);
  const [pbmList, setPbmList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showSpecialtyDrug, setShowSpecialtyDrug] = useState(false);
  const [isGetData, setIsGetData] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [clientData, setClientData] = useState([]);
  const [modalShowMore, setModalShowMore] = useState(false);
  const [importConformationModal, setImportConformationModal] = useState(false);
  const [fileValidation, setFileValidation] = useState("");
  const [isSpinner, setIsSpinner] = useState(false);
  const [Client, setClient] = useState();
  const [selectedPBMName, setSelectedPBMName] = useState("");
  const [importedFile, setImportedFile] = useState(null);
  const [fileTypesData, setFileTypesData] = useState([]);
  const [PBMlist, setPBMlist] = useState();
  const [clientID, setClientID] = useState();
  const [message, setMessage] = useState({
    isModal: false,
    file: "",
    success: undefined,
  });
  const [selectedItem, setSelectedItem] = useState(null);
  const fileRef = useRef();
  const buttonRef = useRef();
  const columnsToShow = [
    { title: "Client Name", field: "ClientName" },
    { title: "Incumbent Name", field: "PBMList" },
    { title: "NDC", field: "NDC11" },
    { title: "Therapy Class", field: "TherapyClass" },
    { title: "Drug Name", field: "DrugName" },
    { title: "Brand or Generic", field: "BrandorGenericIndicator" },
    {
      title: "Mail Specialty - AWP-% Discount",
      field: "MailSpecialtyAWPDiscount",
    },
    {
      title: "Mail Specialty - Dispensing Fee($)",
      field: "MailSpecialtyDispensingFee",
    },
    {
      title: "Retail Specialty  - AWP-% Discount",
      field: "RetailSpecialty_AWP_Discount",
    },
    {
      title: "Retail Specialty - Dispensing Fee($)",
      field: "RetailSpecialtyDispensingFee",
    },
    {
      title: "Specialty Pharmacy - AWP-% Discount",
      field: "SpecialtyPharmacyAWPDiscount",
    },
    {
      title: "Speciatly Pharmacy - Dispensing Fee($)",
      field: "SpecialtyPharmacyDispensingFee",
    },
    { title: "Biosimilar", field: "BiosimilarIndicator" },
    {
      title: "Limited Distribution",
      field: "LimitedDistributionDrugIndicator",
    },
    { title: "Rebateable Drug", field: "Rebateable_Drug" },
  ];
  const column = [
    { title: "Client Name", field: "ClientName" },
    { title: "PBM", field: "PBMList" },
    {
      title: "Actions",
      minWidth: "110px",
      maxWidth: "75px",
      cellStyle: { textAlign: "center" },
      headerStyle: { textAlign: "center" },
      sorting: false,
      render: (rowData) =>
        rowData.status !== "" ? (
          <>
            <IoEyeOutline
              width="11"
              className="m-2 cursor-pointer"
              style={{ fontSize: "15px" }}
              alt="show more"
              onClick={() => {
                getGroupData(rowData?.ClientId, rowData?.PBMList);
                setModalShowMore(true);
                setWitchAction("showMore");
              }}
            />
            {(user?.UserRole === "Pharmacy" || user?.UserRole === "Admin") && (
              <>
                <img
                  src={
                    selectedRow === rowData?.tableData?.id
                      ? editIconWhite
                      : editIcon
                  }
                  width="11"
                  className="m-2 cursor-pointer"
                  alt="edit icon"
                  onClick={() => {
                    setWitchAction("update");
                    getGroupData(rowData?.ClientId, rowData?.PBMList);
                    setRowDataID(rowData?.tableData?.id);
                    setClientID(rowData?.ClientId);
                    setShowModal(true);
                  }}
                />
                <img
                  src={
                    selectedRow === rowData?.ClientId
                      ? deletIconWhite
                      : deletIcon
                  }
                  width="11"
                  className="m-2 cursor-pointer"
                  alt="delete icon"
                  onClick={() => {
                    setWitchAction("delete");
                    setPBMlist(rowData?.PBMList);
                    setClientID(rowData?.ClientId);
                    setSelectedRowData(groupData);
                    setShowModal(true);
                  }}
                />
                <BiSolidDownload
                  width="11"
                  className="m-2 cursor-pointer"
                  style={{ fontSize: "15px" }}
                  alt="download"
                  onClick={() => {
                    setWitchAction("download");
                    getGroupData(
                      rowData?.ClientId,
                      rowData?.PBMList,
                      "download"
                    );
                  }}
                />
              </>
            )}
          </>
        ) : (
          <div className="m-2" style={{ height: "11px", width: "11px" }}></div>
        ),
    },
    
  ];

  const handleEditEnable = (item, value) => {
    let select_item = groupData.find((el) => el.Id === item.Id);
    setSelectedItem(select_item);
  };

  const handleSave = (item, value) => {
    if (selectedItem?.Id === item.Id) {
      const payload = {
        id: item.Id,
        uD_Id: +user.UD_id,
        ndC11: value.NDC11,
        drugName: value.DrugName,
        therapyClass: value.TherapyClass,
        limitedDistributionDrugIndicator:
          value.LimitedDistributionDrugIndicator === "Yes" ? true : false,
        biosimilarIndicator: value.BiosimilarIndicator === "Yes" ? true : false,
        brandorGenericIndicator: value.BrandorGenericIndicator,
        clientName: item.ClientName,
        clientId: item.ClientId,
        mailSpecialtyAWPDiscount: +value.Mail_Specialty_AWP_Discount,
        mailSpecialtyDispensingFee: +value.Mail_Specialty_Dispensing_Fee,
        retailSpecialty_AWP_Discount: +value.Retail_Specialty_AWP_Discount,
        retailSpecialtyDispensingFee: +value.Retail_Specialty_Dispensing_Fee,
        specialtyPharmacyAWPDiscount: +value.Specialty_Pharmacy_AWP_Discount,
        specialtyPharmacyDispensingFee:
          +value.Specialty_Pharmacy_Dispensing_Fee,
        rebateable_Drug: value.Rebateable_Drug,
        pbmList: item.PBMList,
      };
      AddEmpowerXSpecialtyDrugLIst(payload).then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          toastFile("update");
        }
      });
    }
  };

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getData();
    }
    setIsGetData(false);
  }, [showModal]);
  useEffect(() => {
    getData();
    getPBMList();
  }, []);

  const getGroupData = async (ClientId, PBMList, witchAction) => {
    setIsLoading(true);
    try {
      const res = await GetEmpoweRxSpecialtyDrugList(ClientId, PBMList);
      if (res?.status === 200 || res?.status === 204) {
        setGroupData(res.data.data);
        // console.log('download data',res.data.data)
        setSelectedRowData(res.data.data);
        if (witchAction == "download") {
          downloadCSV(
            res.data.data,
            `Specialty_Drug_List_${moment(new Date()).format(
              "MM-DD-yyyy_hh:mm:ss"
            )}`,
            columnsToShow
          );
        }
      }
    } catch (err) {
      console.error({ err });
    } finally {
      setIsLoading(false);
    }
  };

  const getData = () => {
    setIsLoading(true);
    GetEmpoweRxSpecialtyDrugListGroup(user.UD_id)
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          setData(res.data.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const getPBMList = () => {
    GetPBMList()
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          setPbmList(res.data.data);
        }
      })
      .catch((err) => console.log({ err }));
  };

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    if (searchQuery.length > 3 || searchQuery?.length === 0) {
      try {
        let response = await getClientsDatabyPaginationbySearch(
          user?.UD_id,
          page,
          searchQuery
        );
        const data = await response.data.clientsDataModelUDid;
        setClientData([...clientData, ...data]);
        const newOptions = data.map((port) => ({
          value: port.clientName,
          label: port.clientName,
          clientID: port.clientID,
        }));
        return {
          options: newOptions,
          hasMore: newOptions.length >= 1,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error("Error fetching data:", error);
        return {
          options: [],
          hasMore: false,
          additional: {
            page: page,
          },
        };
      }
    } else {
      return {
        options: [{ value: 0, label: "Please type at least 4 characters" }],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }
  };

  const handleFormSubmit = (values, onSubmitProps) => {
    setMessage(true);

    let client_name = Client?.value
      ?.replaceAll("&", "%26")
      .replaceAll("#", "%23");
    buttonRef.current.disabled = true;
    const { file } = values;
    setIsLoading(true);
    if (file === null) {
      setFileValidation("required");
      setIsLoading(false);
      buttonRef.current.disabled = false;
    } else if (fileValidation) {
      toastFile("invalid file");
      setIsLoading(false);
      buttonRef.current.disabled = false;
    } else {
      ImportEmpoweRxSpecialtyDrug(
        Client?.clientID,
        client_name,
        selectedPBMName,
        user.UD_id,
        file
      )
        .then((res) => {
          setIsSpinner(false);
          if (res.status === 200) {
            if (res.data.success) {
              if (res.data.message === "failed") {
                setMessage((prev) => ({
                  isModal: true,
                  file: res.data.file,
                  success: true,
                }));
              }
              setImportConformationModal(true);
            } else {
              switch (res.data.message) {
                case "failed":
                  setMessage((prev) => ({
                    isModal: true,
                    file: res.data.file,
                    success: false,
                  }));
                  break;
                case "Invalid Template!":
                  toastFile(
                    "File with invalid template. Please upload correct file."
                  );
                  break;
                default:
                  toastFile("File Not Uploaded");
                  break;
              }
            }
            setImportedFile(null);
          }
        })
        .catch((err) => {
          toastFile(err?.response?.data);
        })
        .finally(() => {
          setIsLoading(false);
          onSubmitProps.resetForm();
          setShowSpecialtyDrug(false);
          buttonRef.current.disabled = false;
        });
    }
  };

  const handleActions = () => {
    setIsGetData(true);
    setShowModal(false);
  };

  function downloadCSV(data, filename, columns) {
    const mapedaData = data?.map((item) => ({
      ...item,
      ClientName: JSON.stringify(item?.ClientName),
      BiosimilarIndicator: item?.BiosimilarIndicator ? "Yes" : "No",
      LimitedDistributionDrugIndicator: item?.LimitedDistributionDrugIndicator
        ? "Yes"
        : "No",
    }));
    const csv = convertToCSV(mapedaData, columns);
    const csvData = new Blob([csv], { type: "text/csv" });
    const csvUrl = window.URL.createObjectURL(csvData);
    const link = document.createElement("a");
    link.href = csvUrl;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function convertToCSV(objArray, columns) {
    const formattedData = objArray.map((row) => {
      return Object.values(row).map((cell) => {
        // If the cell contains a comma, wrap it with double quotes
        if (cell?.toString()?.includes(",")) {
          return `"${cell}"`;
        }
        return cell;
      });
    });
    const formattedCSVString = formattedData
      .map((row) => row.join(","))
      .join("\n");

    // console.log({formattedCSVString})
    let csv = "";

    const titles = columns.map((column) => column.title);
    const fields = columns.map((column) => column.field);

    csv += titles.join(",") + "\r\n";

    objArray.forEach((obj) => {
      const row = fields.map((field) => {
        return obj[field] !== undefined ? obj[field] : "";
      });
      csv += row.join(",") + "\r\n";
    });

    return csv;
  }

  return (
    <div>
      {/* import model */}
      <Modal
        show={showSpecialtyDrug}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
        size="md"
      >
        <Modal.Header closeButton onHide={() => setShowSpecialtyDrug(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            Import Specialty Drug List
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize
            validationSchema={schema1}
            onSubmit={handleFormSubmit}
            // initialValues={{
            //   file: null,
            //   client: selectedRowData
            //     ? {
            //         value: selectedRowData?.ClientName,
            //         label: selectedRowData?.ClientName,
            //         clientID: selectedRowData?.clientID,
            //       }
            //     : null,
            //   clientID: selectedRowData
            //     ? {
            //         clientID: selectedRowData?.clientID,
            //       }
            //     : 0,
            //   PBM: selectedRowData?.PBMList
            //     ? JSON.stringify(
            //         pbmList.find((d) => d.Name === selectedRowData?.PBMList)
            //       )
            //     : "",
            // }}
            initialValues={{
              file: null,
              client: null,
              clientID: 0,
              PBM: "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              setFieldValue,
              setFieldError,
              resetForm,
              values,
              touched,
              isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row className="mb-2 gap-3">
                  <Col>
                    <Form.Group className="text-start">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Client Name
                        <Required />
                      </Form.Label>
                      <AsyncPaginate
                        name="client"
                        value={values.client}
                        loadOptions={loadOptions}
                        debounceTimeout={2500}
                        onBlur={handleBlur}
                        placeholder="Select Client Name"
                        onChange={(option) => {
                          setFieldValue("client", option);
                          // console.log("option",option.clientID)
                          setClient(option);
                        }}
                        styles={{
                          ...clientListDrpDwnStyles,
                          control: (base) => ({
                            ...clientListDrpDwnStyles.control(base),
                            border: `1px solid ${
                              errors.client && touched.client
                                ? "red"
                                : "lightgrey"
                            }`,
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            ...Fontstyling.label,
                          }),
                        }}
                        isSearchable={true}
                        additional={{
                          page: 1,
                        }}
                        menuPlacement="auto"
                      />
                      {errors.client && touched.client && (
                        <Form.Label style={Fontstyling.errorlabel}>
                          {errors.client}
                        </Form.Label>
                      )}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        PBM
                        <Required />
                      </Form.Label>
                      <Form.Select
                        className="py-1 rounded-0"
                        style={Fontstyling.label}
                        name="PBM"
                        onChange={(event) => {
                          const selectedOption = event.target.value;

                          if (selectedOption !== "") {
                            const parsedItem = JSON.parse(selectedOption);
                            setSelectedPBMName(parsedItem.Name);
                            setFieldValue("PBM", selectedOption);
                          }
                        }}
                        onBlur={handleBlur}
                        isInvalid={
                          values.PBM === "" && errors.PBM && touched.PBM
                        }
                        value={values.PBM}
                      >
                        <option value={""}>Select PBM</option>
                        {pbmList?.map((item, index) => (
                          <option value={JSON.stringify(item)}>
                            {item.Name}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.PBM}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label
                        htmlFor="file"
                        style={Fontstyling.label}
                        className="form-label text-nowrap"
                      >
                        File
                        <Required />
                      </Form.Label>
                      <Form.Control
                        className="rounded-0 py-1"
                        style={Fontstyling.label}
                        type="file"
                        name="file"
                        id="file"
                        accept=".csv"
                        isInvalid={
                          fileValidation || (errors.file && touched.file)
                        }
                        ref={fileRef}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (!file) {
                            setFileValidation("");
                            setFieldValue("file", null);
                          } else if (file.type !== "text/csv") {
                            setFileValidation("Please select a .csv file");
                            setFieldValue("file", e.currentTarget.files[0]);
                          } else {
                            setFileValidation("");
                            setFieldValue("file", e.currentTarget.files[0]);
                          }
                        }}
                      />
                      <Form.Control.Feedback
                        className="text-danger"
                        type="invalid"
                      >
                        {fileValidation || errors.file}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <div className="d-flex align-items-center justify-content-end ">
                  <div className="d-flex align-items-center gap-3 mt-4">
                    <a
                      className="me-2"
                      href="/samplefile/specialty_drug_list_template.csv"
                      style={{
                        textDecoration: "none",
                      }}
                      onMouseOver={(e) => {
                        e.target.style.textDecoration = "underline";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.textDecoration = "none";
                      }}
                      download
                    >
                      Download Template
                    </a>
                    <button
                      className="text-nowrap"
                      style={{ ...Fontstyling.savebutton }}
                      type="submit"
                      disabled={isLoading}
                      ref={buttonRef}
                    >
                      {isLoading ? (
                        <div className="d-flex justify-content-center align-items-center">
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="false"
                            style={{ marginRight: "5px" }}
                          />
                          <span>Uploading...</span>
                        </div>
                      ) : (
                        "Upload File"
                      )}
                    </button>
                    <button
                      className="text-nowrap"
                      style={{ ...Fontstyling.cancelbutton }}
                      type="button"
                      onClick={() => {
                        resetForm();
                        setFieldError("file", "");
                        setFileTypesData([]);
                        setFileValidation("");
                        fileRef.current.value = null;
                        setShowSpecialtyDrug(false);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

      {/* Confirmation model*/}
      <Modal
        show={importConformationModal}
        onHide={() => setImportConformationModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Would you like to override the existing Specialty Drug List(s)?
          <div className="mt-3">Yes = Replaces all Specialty Drug List.</div>
          <div>
            No = Adds new Specialty Drug List to the existing record(s).
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={Fontstyling.savebutton}
            onClick={() => {
              let client_name = Client?.value
                ?.replaceAll("&", "%26")
                .replaceAll("#", "%23");
              setImportConformationModal(false);
              setIsSpinner(true);
              AddDataToEmpoweRxSpecialtyDrug(
                Client?.clientID,
                client_name,
                selectedPBMName,
                user.UD_id,
                true
              ).then((res) => {
                setIsSpinner(false);
                if (res.status === 200) {
                  if (res.data === "failed") {
                    toastFile("File Not Uploaded");
                    // setMessage((prev) => ({ ...prev, isModal: true }));
                  } else {
                    toastFile("imported");
                  }
                  getData();
                }
              });
            }}
          >
            Yes
          </Button>
          <Button
            style={Fontstyling.cancelbutton}
            onClick={() => {
              setImportConformationModal(false);
              setIsSpinner(true);
              AddDataToEmpoweRxSpecialtyDrug(
                Client?.clientID,
                Client?.value,
                selectedPBMName,
                user.UD_id,
                false
              ).then((res) => {
                setIsSpinner(false);
                if (res.status === 200) {
                  if (res.data === "failed") {
                    // setMessage((prev) => ({ ...prev, isModal: true }));
                  } else {
                    toastFile("imported");
                  }
                  getData();
                }
              });
            }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Error model 2 */}
      <Modal
        show={message.isModal && message.success === false}
        onHide={() => setMessage((prev) => ({ ...prev, isModal: false }))}
      >
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          There are blank or invalid values in your import file. Please click
          Download Error Log, correct the import file accordingly, and try
          again.
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              className="bg-transparent border-0 text-primary"
              onClick={() => {
                DownloadCensusErrorFile(message.file).then((data) => {
                  const blob = new Blob([data.data], {
                    type: "text/plain",
                  });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = message.file;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                  setMessage((prev) => ({ ...prev, isModal: false, file: "" }));
                });
              }}
            >
              Download Error Log
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      {isSpinner && (
        <>
          <div
            style={{
              marginTop: "-6%",
              width: "97%",
              height: "70vh",
              display: "flex",
              justifyContent: "center",
              backgroundColor: "transparent",
              position: "absolute",
              zIndex: 11,
            }}
          >
            <div
              style={{
                marginTop: "10%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Spinner
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="false"
              />
              <span>Please Wait</span>
            </div>
          </div>
        </>
      )}

      {/* update model */}
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
        size={witchAction === "delete" ? "md" : "xl"}
        fullscreen={witchAction !== "delete"}
      >
        <Modal.Header
          closeButton
          onHide={() => {
            setShowModal(false);
            setSelectedItem(null);
          }}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            Specialty Drug
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={witchAction === "update" && "pt-0"}>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteEmpoweRxSpecialtyDrugListGroup(clientID, PBMlist).then(
                  (res) => {
                    toastFile("delete");
                    setIsGetData(true);
                    setShowModal(false);
                  }
                );
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <div
              className={
                isLoading && "d-flex align-items-center justify-content-center"
              }
              style={{ width: "100%", height: "100%" }}
            >
              {isLoading ? (
                <Loader size="lg" speed="slow" />
              ) : (
                <Formik
                  enableReinitialize
                  validationSchema={schema}
                  onSubmit={handleActions}
                  // initialValues={initialValues}

                  initialValues={{
                    PBM: selectedRowData?.[0]?.PBMList
                      ? JSON.stringify(
                          pbmList.find(
                            (d) => d.Name === selectedRowData?.[0]?.PBMList
                          )
                        )
                      : "",
                    client: selectedRowData
                      ? {
                          value: selectedRowData?.[0]?.ClientName,
                          label: selectedRowData?.[0]?.ClientName,
                          clientID: selectedRowData?.[0]?.clientID,
                        }
                      : null,
                    clientID: selectedRowData
                      ? {
                          clientID: selectedRowData?.[0]?.clientID,
                        }
                      : 0,
                  }}
                >
                  {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    values,
                    touched,
                    isValid,
                    errors,
                  }) => (
                    <Form onSubmit={handleSubmit}>
                      <Row className="mb-3 gap-3">
                        <Col>
                          <Form.Group className="text-start">
                            <Form.Label
                              className="text-nowrap"
                              style={Fontstyling.label}
                            >
                              Client Name
                              <Required />
                            </Form.Label>
                            <AsyncPaginate
                              name="client"
                              value={values.client}
                              loadOptions={loadOptions}
                              debounceTimeout={2500}
                              onBlur={handleBlur}
                              placeholder="Select Client Name"
                              isDisabled
                              onChange={(option) => {
                                setFieldValue("client", option);
                              }}
                              styles={{
                                ...clientListDrpDwnStyles,
                                control: (base) => ({
                                  ...clientListDrpDwnStyles.control(base),
                                  border: `1px solid ${
                                    errors.client && touched.client
                                      ? "red"
                                      : "lightgrey"
                                  }`,
                                  background: "#e9ecef",
                                  color: "black",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  ...Fontstyling.label,
                                  color: "black",
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: "black",
                                }),
                              }}
                              isSearchable={true}
                              additional={{
                                page: 1,
                              }}
                              menuPlacement="auto"
                            />
                            {errors.client && touched.client && (
                              <Form.Label style={Fontstyling.errorlabel}>
                                {errors.client}
                              </Form.Label>
                            )}
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group>
                            <Form.Label
                              className="text-nowrap"
                              style={Fontstyling.label}
                            >
                              PBM
                              <Required />
                            </Form.Label>
                            <Form.Select
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              name="PBM"
                              onChange={handleChange}
                              disabled
                              onBlur={handleBlur}
                              isInvalid={
                                values.PBM === "" && errors.PBM && touched.PBM
                              }
                              value={values.PBM}
                            >
                              <option value={""}>Select PBM</option>
                              {pbmList?.map((item, index) => (
                                <option value={JSON.stringify(item)}>
                                  {item.Name}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.PBM}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Table bordered hover style={{ overflowX: "scroll" }}>
                        <thead
                          style={{ position: "sticky", top: 0, zIndex: 1 }}
                        >
                          <tr className="text-center">
                            <th style={Fontstyling.label}>Action</th>
                            <th style={Fontstyling.label}>
                              NDC
                              <Required />
                            </th>
                            <th style={Fontstyling.label}>
                              Drug Name
                              <Required />
                            </th>
                            <th style={Fontstyling.label}>
                              Therapy Class
                              <Required />
                            </th>
                            <th style={Fontstyling.label}>
                              Limited Distribution Drug Indicator
                              <Required />
                            </th>
                            <th style={Fontstyling.label}>
                              Biosimilar Indicator
                              <Required />
                            </th>
                            <th style={Fontstyling.label}>
                              Brand or Generic Indicator
                              <Required />
                            </th>
                            <th style={Fontstyling.label}>
                              Mail Specialty AWP Discount
                              <Required />
                            </th>
                            <th style={Fontstyling.label}>
                              Mail Specialty Dispensing Fee($)
                              <Required />
                            </th>
                            <th style={Fontstyling.label}>
                              Retail Specialty AWP Discount
                              <Required />
                            </th>
                            <th style={Fontstyling.label}>
                              Retail Specialty Dispensing Fee($)
                              <Required />
                            </th>
                            <th style={Fontstyling.label}>
                              Specialty Pharmacy AWP Discount
                              <Required />
                            </th>
                            <th style={Fontstyling.label}>
                              Specialty Pharmacy Dispensing Fee($)
                              <Required />
                            </th>
                            <th style={Fontstyling.label}>
                              Rebateable Drug
                              <Required />
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {groupData.map((item, index) => (
                            <TableRow
                              key={index}
                              item={item}
                              index={index}
                              selectedItem={selectedItem}
                              setSelectedItem={setSelectedItem}
                              selectedRowData={selectedRowData}
                              handleSave={handleSave}
                              handleEditEnable={handleEditEnable}
                              setWitchAction={setWitchAction}
                              schema={schema}
                            />
                          ))}
                        </tbody>
                      </Table>
                    </Form>
                  )}
                </Formik>
              )}
            </div>
          )}
        </Modal.Body>
        {witchAction !== "delete" && (
          <Modal.Footer>
            <div className="d-flex justify-content-end my-1">
              <button
                style={Fontstyling.cancelbutton}
                type="reset"
                onClick={() => {
                  setShowModal(false);
                  setSelectedItem(null);
                }}
              >
                Close
              </button>
            </div>
          </Modal.Footer>
        )}
      </Modal>
      {/* show more mode */}
      <Modal
        show={modalShowMore}
        aria-labelledby="contained-modal-title-vcenter"
        fullscreen
      >
        <Modal.Header closeButton onHide={() => setModalShowMore(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            Specialty Drug
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <Formik
            enableReinitialize
            initialValues={{
              PBM: selectedRowData?.[0]?.PBMList
                ? JSON.stringify(
                    pbmList.find(
                      (d) => d.Name === selectedRowData?.[0]?.PBMList
                    )
                  )
                : "",
              NDC11: selectedRowData?.NDC11 ?? "",
              DrugName: selectedRowData?.DrugName ?? "",
              TherapyClass: selectedRowData?.TherapyClass ?? "",
              AWPDiscount: selectedRowData?.AWPDiscount ?? "",
              LimitedDistributionDrugIndicator: selectedRowData
                ? selectedRowData?.LimitedDistributionDrugIndicator
                  ? "Yes"
                  : "No"
                : "",
              BiosimilarIndicator: selectedRowData
                ? selectedRowData?.BiosimilarIndicator
                  ? "Yes"
                  : "No"
                : "",
              BrandorGenericIndicator:
                selectedRowData?.BrandorGenericIndicator ?? "",
              client: selectedRowData
                ? {
                    value: selectedRowData?.[0]?.ClientName,
                    label: selectedRowData?.[0]?.ClientName,
                    clientID: selectedRowData?.[0]?.clientID,
                  }
                : null,
              clientID: selectedRowData
                ? {
                    clientID: selectedRowData?.clientID,
                  }
                : 0,
              Mail_Specialty_AWP_Discount:
                selectedRowData?.MailSpecialtyAWPDiscount * 100 ?? "",
              Mail_Specialty_Dispensing_Fee:
                selectedRowData?.MailSpecialtyDispensingFee ?? "",
              Retail_Specialty_AWP_Discount:
                selectedRowData?.RetailSpecialty_AWP_Discount ?? "",
              Retail_Specialty_Dispensing_Fee:
                selectedRowData?.RetailSpecialtyDispensingFee ?? "",
              Specialty_Pharmacy_AWP_Discount:
                selectedRowData?.SpecialtyPharmacyAWPDiscount ?? "",
              Specialty_Pharmacy_Dispensing_Fee:
                selectedRowData?.SpecialtyPharmacyDispensingFee ?? "",
              Rebateable_Drug: selectedRowData?.Rebateable_Drug ?? "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              setFieldValue,
              values,
              touched,
              isValid,
              errors,
            }) => (
              <Form>
                <Row className="mb-2 gap-3">
                  <Col>
                    <Form.Group className="text-start ">
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Client Name
                        <Required />
                      </Form.Label>
                      <AsyncPaginate
                        name="client"
                        value={values.client}
                        loadOptions={loadOptions}
                        debounceTimeout={2500}
                        onBlur={handleBlur}
                        isDisabled
                        placeholder="Select Client Name"
                        onChange={(option) => {
                          setFieldValue("client", option);
                        }}
                        styles={{
                          ...clientListDrpDwnStyles,
                          control: (base) => ({
                            ...clientListDrpDwnStyles.control(base),
                            border: `1px solid ${
                              errors.client && touched.client
                                ? "red"
                                : "lightgrey"
                            }`,
                            background: "#e9ecef",
                            color: "black",
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            ...Fontstyling.label,
                            color: "black",
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: "black",
                          }),
                        }}
                        isSearchable={true}
                        additional={{
                          page: 1,
                        }}
                        menuPlacement="auto"
                      />
                      {errors.client && touched.client && (
                        <Form.Label style={Fontstyling.errorlabel}>
                          {errors.client}
                        </Form.Label>
                      )}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        PBM
                        <Required />
                      </Form.Label>
                      <Form.Select
                        className="py-1 rounded-0"
                        style={Fontstyling.label}
                        name="PBM"
                        onChange={handleChange}
                        disabled
                        onBlur={handleBlur}
                        isInvalid={
                          values.PBM === "" && errors.PBM && touched.PBM
                        }
                        value={values.PBM}
                      >
                        <option value={""}>Select PBM</option>
                        {pbmList?.map((item, index) => (
                          <option value={JSON.stringify(item)}>
                            {item.Name}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.PBM}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Table bordered hover style={{ overflowX: "scroll" }}>
                  <thead
                    className="thead-dark"
                    style={{ position: "sticky", top: 0, zIndex: 1 }}
                  >
                    <tr className="text-center">
                      <th style={Fontstyling.label}>
                        NDC
                        <Required />
                      </th>
                      <th style={Fontstyling.label}>
                        Drug Name
                        <Required />
                      </th>
                      <th style={Fontstyling.label}>
                        Therapy Class
                        <Required />
                      </th>
                      <th style={Fontstyling.label}>
                        Limited Distribution Drug Indicator
                        <Required />
                      </th>
                      <th style={Fontstyling.label}>
                        Biosimilar Indicator
                        <Required />
                      </th>
                      <th style={Fontstyling.label}>
                        Brand or Generic Indicator
                        <Required />
                      </th>
                      <th style={Fontstyling.label}>
                        Mail Specialty AWP Discount
                        <Required />
                      </th>
                      <th style={Fontstyling.label}>
                        Mail Specialty Dispensing Fee($)
                        <Required />
                      </th>
                      <th style={Fontstyling.label}>
                        Retail Specialty AWP Discount
                        <Required />
                      </th>
                      <th style={Fontstyling.label}>
                        Retail Specialty Dispensing Fee($)
                        <Required />
                      </th>
                      <th style={Fontstyling.label}>
                        Specialty Pharmacy AWP Discount
                        <Required />
                      </th>
                      <th style={Fontstyling.label}>
                        Specialty Pharmacy Dispensing Fee($)
                        <Required />
                      </th>
                      <th style={Fontstyling.label}>
                        Rebateable Drug
                        <Required />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupData.map((item, index) => (
                      <TableRowView
                        key={index}
                        item={item}
                        index={index}
                        selectedItem={selectedItem}
                        setSelectedItem={setSelectedItem}
                        selectedRowData={selectedRowData}
                      />
                    ))}
                  </tbody>
                </Table>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

      <div style={Fontstyling.errorlabel} className="w-full fw-bold  mb-3">
        The information in whole or in part contained herein is confidential and
        proprietary. Sharing any information element by any mode of transmission
        without express written permission from the incumbent PBM to the any
        recipient is prohibited.
      </div>
      <div className="d-flex align-item-center justify-content-between py-3 border-bottom">
        <div style={Fontstyling.heading}>Specialty Drug List</div>
        <div>
        {(user?.UserRole === "Pharmacy" || user?.UserRole === "Admin") && <CustomButton
            onClick={() => {
              setShowSpecialtyDrug(true);
            }}
          >
            Import Specialty Drug List
          </CustomButton>}
        </div>
      </div>
      <CustomMaterialTable
        overrideColumn={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
        isExport={false}
        isEdit={true}
        isDelete={true}
      />
    </div>
  );
};

export default SpecialtyDrugList;

const TableRowView = ({ item, index }) => {
  const initialValues = {
    NDC11: item?.NDC11 ?? "",
    DrugName: item?.DrugName ?? "",
    TherapyClass: item?.TherapyClass ?? "",
    AWPDiscount: item?.AWPDiscount ?? "",
    LimitedDistributionDrugIndicator: item
      ? item?.LimitedDistributionDrugIndicator
        ? "Yes"
        : "No"
      : "",
    BiosimilarIndicator: item ? (item?.BiosimilarIndicator ? "Yes" : "No") : "",
    BrandorGenericIndicator: item?.BrandorGenericIndicator ?? "",
    Mail_Specialty_AWP_Discount:
      (item?.MailSpecialtyAWPDiscount * 100).toFixed(2) + "%" ?? "",
    Mail_Specialty_Dispensing_Fee: item?.MailSpecialtyDispensingFee ?? "",
    Retail_Specialty_AWP_Discount:
      (item?.RetailSpecialty_AWP_Discount * 100).toFixed(2) + "%" ?? "",
    Retail_Specialty_Dispensing_Fee: item?.RetailSpecialtyDispensingFee ?? "",
    Specialty_Pharmacy_AWP_Discount:
      (item?.SpecialtyPharmacyAWPDiscount * 100).toFixed(2) + "%" ?? "",
    Specialty_Pharmacy_Dispensing_Fee:
      item?.SpecialtyPharmacyDispensingFee ?? "",
    Rebateable_Drug: item?.Rebateable_Drug ?? "",
  };

  return (
    <Formik
      key={index}
      enableReinitialize
      validationSchema={schema}
      initialValues={initialValues}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
        setFieldValue,
      }) => (
        <tr key={index}>
          <td>
            <InputGroup style={{ width: "100px" }}>
              <Form.Control
                name="NDC11"
                className="py-1 rounded-0"
                style={Fontstyling.label}
                disabled
                value={values.NDC11}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.NDC11}
              />
              <Form.Control.Feedback type="invalid">
                {errors.NDC11}
              </Form.Control.Feedback>
            </InputGroup>
          </td>
          <td>
            <InputGroup style={{ width: "100px" }}>
              <Form.Control
                name="DrugName"
                className="py-1 rounded-0"
                style={Fontstyling.label}
                value={values.DrugName}
                disabled
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={30}
                isInvalid={!!errors.DrugName}
              />
              <Form.Control.Feedback type="invalid">
                {errors.DrugName}
              </Form.Control.Feedback>
            </InputGroup>
          </td>
          <td>
            <InputGroup style={{ width: "100px" }}>
              <Form.Control
                name="TherapyClass"
                className="py-1 rounded-0"
                style={Fontstyling.label}
                value={values.TherapyClass}
                disabled
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={30}
                isInvalid={!!errors.TherapyClass}
              />
              <Form.Control.Feedback type="invalid">
                {errors.TherapyClass}
              </Form.Control.Feedback>
            </InputGroup>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Control
                className="py-1 rounded-0"
                style={Fontstyling.label}
                name="LimitedDistributionDrugIndicator"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled
                isInvalid={
                  errors.LimitedDistributionDrugIndicator &&
                  touched.LimitedDistributionDrugIndicator
                }
                value={values.LimitedDistributionDrugIndicator}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.LimitedDistributionDrugIndicator}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Control
                className="py-1 rounded-0"
                style={Fontstyling.label}
                name="BiosimilarIndicator"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled
                isInvalid={
                  errors.BiosimilarIndicator && touched.BiosimilarIndicator
                }
                value={values.BiosimilarIndicator}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.BiosimilarIndicator}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Control
                className="py-1 rounded-0"
                style={Fontstyling.label}
                name="BrandorGenericIndicator"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled
                isInvalid={
                  errors.BrandorGenericIndicator &&
                  touched.BrandorGenericIndicator
                }
                value={values.BrandorGenericIndicator}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.BrandorGenericIndicator}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Control
                className="py-1 rounded-0"
                style={Fontstyling.label}
                name="Mail_Specialty_AWP_Discount"
                onChange={handleChange}
                disabled
                onBlur={handleBlur}
                isInvalid={
                  errors.Mail_Specialty_AWP_Discount &&
                  touched.Mail_Specialty_AWP_Discount
                }
                value={values.Mail_Specialty_AWP_Discount}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.Mail_Specialty_AWP_Discount}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group className="text-start" style={{ width: "100px" }}>
              {/* <InputGroup>
                <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text> */}
              <Form.Control
                className="py-1 rounded-0"
                style={Fontstyling.label}
                name="Mail_Specialty_Dispensing_Fee"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled
                isInvalid={
                  errors.Mail_Specialty_Dispensing_Fee &&
                  touched.Mail_Specialty_Dispensing_Fee
                }
                value={values.Mail_Specialty_Dispensing_Fee}
              ></Form.Control>
              {/* </InputGroup> */}
              <Form.Control.Feedback type="invalid">
                {errors.Mail_Specialty_Dispensing_Fee}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Control
                className="py-1 rounded-0"
                style={Fontstyling.label}
                name="Retail_Specialty_AWP_Discount"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled
                isInvalid={
                  errors.Retail_Specialty_AWP_Discount &&
                  touched.Retail_Specialty_AWP_Discount
                }
                value={values.Retail_Specialty_AWP_Discount}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.Retail_Specialty_AWP_Discount}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group className="text-start" style={{ width: "100px" }}>
              {/* <InputGroup>
                <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text> */}
              <Form.Control
                className="py-1 rounded-0"
                style={Fontstyling.label}
                name="Retail_Specialty_Dispensing_Fee"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled
                isInvalid={
                  errors.Retail_Specialty_Dispensing_Fee &&
                  touched.Retail_Specialty_Dispensing_Fee
                }
                value={values.Retail_Specialty_Dispensing_Fee}
              ></Form.Control>
              {/* </InputGroup> */}
              <Form.Control.Feedback type="invalid">
                {errors.Retail_Specialty_Dispensing_Fee}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Control
                className="py-1 rounded-0"
                style={Fontstyling.label}
                name="Specialty_Pharmacy_AWP_Discount"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled
                isInvalid={
                  errors.Specialty_Pharmacy_AWP_Discount &&
                  touched.Specialty_Pharmacy_AWP_Discount
                }
                value={values.Specialty_Pharmacy_AWP_Discount}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.Specialty_Pharmacy_AWP_Discount}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group className="text-start" style={{ width: "100px" }}>
              {/* <InputGroup>
                <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text> */}
              <Form.Control
                className="py-1 rounded-0"
                style={Fontstyling.label}
                name="Specialty_Pharmacy_Dispensing_Fee"
                onChange={handleChange}
                disabled
                onBlur={handleBlur}
                isInvalid={
                  errors.Specialty_Pharmacy_Dispensing_Fee &&
                  touched.Specialty_Pharmacy_Dispensing_Fee
                }
                value={values.Specialty_Pharmacy_Dispensing_Fee}
              ></Form.Control>
              {/* </InputGroup> */}
              <Form.Control.Feedback type="invalid">
                {errors.Specialty_Pharmacy_Dispensing_Fee}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Control
                className="py-1 rounded-0"
                style={Fontstyling.label}
                name="Rebateable_Drug"
                onChange={handleChange}
                disabled
                onBlur={handleBlur}
                isInvalid={errors.Rebateable_Drug && touched.Rebateable_Drug}
                value={values.Rebateable_Drug}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.Rebateable_Drug}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
        </tr>
      )}
    </Formik>
  );
};

const TableRow = ({
  item,
  index,
  selectedItem,
  setSelectedItem,
  selectedRowData,
  handleSave,
  handleEditEnable,
  setWitchAction,
  schema,
}) => {
  const initialValues = {
    NDC11: item?.NDC11 ?? "",
    DrugName: item?.DrugName ?? "",
    TherapyClass: item?.TherapyClass ?? "",
    AWPDiscount: item?.AWPDiscount ?? "",
    LimitedDistributionDrugIndicator: item
      ? item?.LimitedDistributionDrugIndicator
        ? "Yes"
        : "No"
      : "",
    BiosimilarIndicator: item ? (item?.BiosimilarIndicator ? "Yes" : "No") : "",
    BrandorGenericIndicator: item?.BrandorGenericIndicator ?? "",
    Mail_Specialty_AWP_Discount: item?.MailSpecialtyAWPDiscount ?? "",
    Mail_Specialty_Dispensing_Fee: item?.MailSpecialtyDispensingFee ?? "",
    Retail_Specialty_AWP_Discount: item?.RetailSpecialty_AWP_Discount ?? "",
    Retail_Specialty_Dispensing_Fee: item?.RetailSpecialtyDispensingFee ?? "",
    Specialty_Pharmacy_AWP_Discount: item?.SpecialtyPharmacyAWPDiscount ?? "",
    Specialty_Pharmacy_Dispensing_Fee:
      item?.SpecialtyPharmacyDispensingFee ?? "",
    Rebateable_Drug: item?.Rebateable_Drug ?? "",
  };

  return (
    <Formik
      key={index}
      enableReinitialize
      validationSchema={schema}
      onSubmit={(values, hand) => {
        handleSave(item, values);
        setSelectedItem(null);
      }}
      initialValues={initialValues}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
        setFieldValue,
      }) => (
        <tr key={index}>
          <td>
            {selectedItem?.Id === item.Id ? (
              <div
                className="rounded-5 pb-1 text-center bg-success cursor-pointer"
                onClick={(e) => {
                  setWitchAction("update");
                  handleSubmit(e);
                }}
              >
                <IoCheckmarkCircle size={20} color="white" alt="check icon" />
              </div>
            ) : (
              <div
                className="rounded-5 pb-1 text-center bg-warning cursor-pointer"
                onClick={() => {
                  selectedItem === null && handleEditEnable(item, values);
                }}
              >
                <FaPencil size={14} color="black" alt="check icon" />
              </div>
            )}
          </td>
          <td>
            <InputGroup style={{ width: "100px" }}>
              <Form.Control
                name="NDC11"
                className="py-1 rounded-0"
                style={
                  selectedItem?.Id !== item.Id
                    ? Fontstyling.label
                    : {
                        ...Fontstyling.label,
                        backgroundColor: "rgb(219 239 219)",
                      }
                }
                value={values.NDC11}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={selectedItem?.Id === item.Id ? false : true}
                isInvalid={!!errors.NDC11}
              />
              <Form.Control.Feedback type="invalid">
                {errors.NDC11}
              </Form.Control.Feedback>
            </InputGroup>
          </td>
          <td>
            <InputGroup style={{ width: "100px" }}>
              <Form.Control
                name="DrugName"
                className="py-1 rounded-0"
                style={
                  selectedItem?.Id !== item.Id
                    ? Fontstyling.label
                    : {
                        ...Fontstyling.label,
                        backgroundColor: "rgb(219 239 219)",
                      }
                }
                value={values.DrugName}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={selectedItem?.Id === item.Id ? false : true}
                maxLength={30}
                isInvalid={!!errors.DrugName}
              />
              <Form.Control.Feedback type="invalid">
                {errors.DrugName}
              </Form.Control.Feedback>
            </InputGroup>
          </td>
          <td>
            <InputGroup style={{ width: "100px" }}>
              <Form.Control
                name="TherapyClass"
                className="py-1 rounded-0"
                style={
                  selectedItem?.Id !== item.Id
                    ? Fontstyling.label
                    : {
                        ...Fontstyling.label,
                        backgroundColor: "rgb(219 239 219)",
                      }
                }
                value={values.TherapyClass}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={selectedItem?.Id === item.Id ? false : true}
                maxLength={30}
                isInvalid={!!errors.TherapyClass}
              />
              <Form.Control.Feedback type="invalid">
                {errors.TherapyClass}
              </Form.Control.Feedback>
            </InputGroup>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Select
                className="py-1 rounded-0"
                style={
                  selectedItem?.Id !== item.Id
                    ? Fontstyling.label
                    : {
                        ...Fontstyling.label,
                        backgroundColor: "rgb(219 239 219)",
                      }
                }
                name="LimitedDistributionDrugIndicator"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={selectedItem?.Id === item.Id ? false : true}
                isInvalid={
                  errors.LimitedDistributionDrugIndicator &&
                  touched.LimitedDistributionDrugIndicator
                }
                value={values.LimitedDistributionDrugIndicator}
              >
                <option value={""}>
                  Select Limited Distribution Drug Indicator
                </option>
                {["Yes", "No"].map((item, index) => (
                  <option value={item}>{item}</option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.LimitedDistributionDrugIndicator}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Select
                className="py-1 rounded-0"
                style={
                  selectedItem?.Id !== item.Id
                    ? Fontstyling.label
                    : {
                        ...Fontstyling.label,
                        backgroundColor: "rgb(219 239 219)",
                      }
                }
                name="BiosimilarIndicator"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={selectedItem?.Id === item.Id ? false : true}
                isInvalid={
                  errors.BiosimilarIndicator && touched.BiosimilarIndicator
                }
                value={values.BiosimilarIndicator}
              >
                <option value={""}>Select Biosimilar Indicator</option>
                {["Yes", "No"].map((item, index) => (
                  <option value={item}>{item}</option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.BiosimilarIndicator}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Select
                className="py-1 rounded-0"
                style={
                  selectedItem?.Id !== item.Id
                    ? Fontstyling.label
                    : {
                        ...Fontstyling.label,
                        backgroundColor: "rgb(219 239 219)",
                      }
                }
                name="BrandorGenericIndicator"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={selectedItem?.Id === item.Id ? false : true}
                isInvalid={
                  errors.BrandorGenericIndicator &&
                  touched.BrandorGenericIndicator
                }
                value={values.BrandorGenericIndicator}
              >
                <option value={""}>Select Brand or Generic Indicator</option>
                {["Brand", "Generic"].map((item, index) => (
                  <option value={item}>{item}</option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.BrandorGenericIndicator}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Control
                className="py-1 rounded-0"
                style={
                  selectedItem?.Id !== item.Id
                    ? Fontstyling.label
                    : {
                        ...Fontstyling.label,
                        backgroundColor: "rgb(219 239 219)",
                      }
                }
                name="Mail_Specialty_AWP_Discount"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={selectedItem?.Id === item.Id ? false : true}
                isInvalid={
                  errors.Mail_Specialty_AWP_Discount &&
                  touched.Mail_Specialty_AWP_Discount
                }
                value={values.Mail_Specialty_AWP_Discount}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.Mail_Specialty_AWP_Discount}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group className="text-start" style={{ width: "100px" }}>
              {/* <InputGroup>
                <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text> */}
              <Form.Control
                className="py-1 rounded-0"
                style={
                  selectedItem?.Id !== item.Id
                    ? Fontstyling.label
                    : {
                        ...Fontstyling.label,
                        backgroundColor: "rgb(219 239 219)",
                      }
                }
                name="Mail_Specialty_Dispensing_Fee"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={selectedItem?.Id === item.Id ? false : true}
                isInvalid={
                  errors.Mail_Specialty_Dispensing_Fee &&
                  touched.Mail_Specialty_Dispensing_Fee
                }
                value={values.Mail_Specialty_Dispensing_Fee}
              ></Form.Control>
              {/* </InputGroup> */}
              <Form.Control.Feedback type="invalid">
                {errors.Mail_Specialty_Dispensing_Fee}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Control
                className="py-1 rounded-0"
                style={
                  selectedItem?.Id !== item.Id
                    ? Fontstyling.label
                    : {
                        ...Fontstyling.label,
                        backgroundColor: "rgb(219 239 219)",
                      }
                }
                name="Retail_Specialty_AWP_Discount"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={selectedItem?.Id === item.Id ? false : true}
                isInvalid={
                  errors.Retail_Specialty_AWP_Discount &&
                  touched.Retail_Specialty_AWP_Discount
                }
                value={values.Retail_Specialty_AWP_Discount}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.Retail_Specialty_AWP_Discount}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group className="text-start" style={{ width: "100px" }}>
              {/* <InputGroup>
                <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text> */}
              <Form.Control
                className="py-1 rounded-0"
                style={
                  selectedItem?.Id !== item.Id
                    ? Fontstyling.label
                    : {
                        ...Fontstyling.label,
                        backgroundColor: "rgb(219 239 219)",
                      }
                }
                name="Retail_Specialty_Dispensing_Fee"
                onChange={handleChange}
                disabled={selectedItem?.Id === item.Id ? false : true}
                onBlur={handleBlur}
                isInvalid={
                  errors.Retail_Specialty_Dispensing_Fee &&
                  touched.Retail_Specialty_Dispensing_Fee
                }
                value={values.Retail_Specialty_Dispensing_Fee}
              ></Form.Control>
              {/* </InputGroup> */}
              <Form.Control.Feedback type="invalid">
                {errors.Retail_Specialty_Dispensing_Fee}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Control
                className="py-1 rounded-0"
                style={
                  selectedItem?.Id !== item.Id
                    ? Fontstyling.label
                    : {
                        ...Fontstyling.label,
                        backgroundColor: "rgb(219 239 219)",
                      }
                }
                name="Specialty_Pharmacy_AWP_Discount"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={selectedItem?.Id === item.Id ? false : true}
                isInvalid={
                  errors.Specialty_Pharmacy_AWP_Discount &&
                  touched.Specialty_Pharmacy_AWP_Discount
                }
                value={values.Specialty_Pharmacy_AWP_Discount}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.Specialty_Pharmacy_AWP_Discount}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group className="text-start" style={{ width: "100px" }}>
              {/* <InputGroup>
                <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text> */}
              <Form.Control
                className="py-1 rounded-0"
                style={
                  selectedItem?.Id !== item.Id
                    ? Fontstyling.label
                    : {
                        ...Fontstyling.label,
                        backgroundColor: "rgb(219 239 219)",
                      }
                }
                name="Specialty_Pharmacy_Dispensing_Fee"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={selectedItem?.Id === item.Id ? false : true}
                isInvalid={
                  errors.Specialty_Pharmacy_Dispensing_Fee &&
                  touched.Specialty_Pharmacy_Dispensing_Fee
                }
                value={values.Specialty_Pharmacy_Dispensing_Fee}
              ></Form.Control>
              {/* </InputGroup> */}
              <Form.Control.Feedback type="invalid">
                {errors.Specialty_Pharmacy_Dispensing_Fee}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group style={{ width: "100px" }}>
              <Form.Select
                className="py-1 rounded-0"
                style={
                  selectedItem?.Id !== item.Id
                    ? Fontstyling.label
                    : {
                        ...Fontstyling.label,
                        backgroundColor: "rgb(219 239 219)",
                      }
                }
                name="Rebateable_Drug"
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={selectedItem?.Id === item.Id ? false : true}
                isInvalid={errors.Rebateable_Drug && touched.Rebateable_Drug}
                value={values.Rebateable_Drug}
              >
                <option value={""}>Select Rebateable Drug</option>
                {["Yes", "No"].map((item, index) => (
                  <option value={item}>{item}</option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.Rebateable_Drug}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
        </tr>
      )}
    </Formik>
  );
};
